import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'ProductCatalogList',
})(({ spacing, aspectRatio, typography }) => ({
  spacingContainer: {
    padding: spacing(4),
  },
  cardWrapper: {
    marginTop: spacing(3),
  },
  productCard: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  productImage: {
    overflow: 'hidden',
    aspectRatio: aspectRatio['16/9'],
    display: 'flex',
    borderRadius: typography.pxToRem(16),
    '& img': {
      objectFit: 'cover',
      maxWidth: '100%',
      display: 'block',
      width: '100%',
      minHeight: typography.pxToRem(280),
      height: 'auto',
      transition: 'transform 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
  },
  textContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(1),
  },
  productTitle: {
    cursor: 'pointer',
    marginBottom: spacing(-1),
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    textDecoration: 'none',
    fontWeight: typography.fontWeightMedium,
    lineHeight: typography.pxToRem(26.4),
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  productPrice: {
    fontWeight: typography.fontWeightMedium,
    lineHeight: typography.pxToRem(26.4),
  },
}));

export default useStyles;
